export default __webpack_public_path__ + "static/media/Sansita-Regular.a9ec3c79.ttf";